/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

document.addEventListener('DOMContentLoaded', function() {
  const title = $('.playfair_title, .playfair_hero_title');

  title.each(function() {
    const currentTitle = $(this);
    if (currentTitle.find('span.font-playfair').length === 0) {
      let labelContent = currentTitle.html();
      let updatedContent = labelContent.replace(/\b(the latest|the complete look|bestsellers|Story|Story\.\.\.|asked questions|us|newsletter|the Club|by category|your team)\b/gi, '<i><span class="font-playfair">$1</span></i>');
      currentTitle.html(updatedContent);
    }
  });

  const cartButtons = document.querySelectorAll('[data-drawer-toggle="drawer-cart"]');
  const container = document.getElementById('cart-drawer-recommendations-container');
  const cartSection = 'cart-drawer-refresher';


});



  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
